export default class ApiError {
	static NO_ERROR = 0;

	// Common
	static INVALID_REQUEST = 1;
	static INVALID_FORMAT = 2;
	static ALREADY_EXIST = 3;
	static NO_FOUND = 4;
	static PERMISSION_DENIED = 5;
	static INVALID_SOURCE_ID = 6;
	static RETRY_REQUEST = 7;
	static INVALID_STATUS = 8;
	static INVALID_ROLE = 9;
	static INVALID_TOKEN = 10;
	static INVALID_TOKEN_PAIRN = 11;
	static INVALID_API_LOGIN_TOKEN = 12;

	// Database
	static DB_UNHANDLED_EXCEPTION = 11;
	static DB_DUPLICATED_ENTRY = 12;

	//Member
	static PASSWORD_CHANGED_REQUIRED = 601;
	static PASSWORD_EXPIRED = 602;
	static ACCOUNT_IS_INACTIVE = 603;
	static PASSWORD_FORMAT_ERROR = 604;
	static INVALID_USER_OR_PASSWORD = 605;
	static INVALID_PASSWORD = 606;
	static INVALID_VERIFICATION_CODE = 607;
	static VERIFICATION_CODE_IN_COOLDOWN = 608;
	static VERIFICATION_CODE_EXPIRED = 609;
	static VERIFICATION_CODE_FAILED_TOO_MANY_TIMES = 610;
	static VERIFICATION_CODE_CANNOT_SEND = 611;
	static LOGIN_FAILED_COUNT_LIMIT = 612;
	static PASSWORD_LOGIN_IS_DISABLED = 613;
	static GET_LINE_ACCESS_TOKEN_FAILED = 614;
	static MOBILE_USED = 615;
	static INVALID_MOBILE = 616;
	static ALREADY_RESERVED = 617;

	// CRM
	static CRM_FAILED = 701;
	static MAAC_FAILED = 702;
}
